import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'react-admin';
const { REACT_APP_DATA_PROVIDER_URL } = process.env;
let baseURL = REACT_APP_DATA_PROVIDER_URL;

export default (type, params) => {
    // called when the user attempts to log in
    

    if (type === AUTH_LOGIN) {
        const { username, password, ipaddress } = params;
        const request = new Request(baseURL + '/user/login', {
            method: 'POST',
            body: JSON.stringify({ username, password, ipaddress }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        })
        return fetch(request)
            .then(response => {
                
                if (response.status < 200 || response.status >= 300) {
                    response.json().then(json => {
                        json.warning && alert(json.warning)
                        
                    });
                    
                    throw new Error(response.error);
                }
                return response.json();
            })
            
            .then(({ token }) => {
                localStorage.setItem('token', token);
                localStorage.setItem('username', username);
            })
/*
            .then(({ authtoken }) => {
                localStorage.setItem('authtoken', authtoken);
            });
*/      
        return Promise.resolve();
    }
        
    
    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('username');
        localStorage.removeItem('token');
        localStorage.clear();
        sessionStorage && sessionStorage.clear();
        return Promise.resolve();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        const { status } = params;
        if (status === 401 || status === 403) {
            localStorage.removeItem('username');
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
        return localStorage.getItem('username')
            ? Promise.resolve()
            : Promise.reject();
    }
    return Promise.reject('Unknown method');
};